export enum ConversationType {
  Group = "group",
  Direct = "direct"
}
